<style lang="scss" scoped>
  .table {
    table-layout: fixed;
    margin-top: 10px;
    font-size: 12px;
    .order-list-item {
      color: #999;
      line-height: 20px;
    }
    border-collapse: separate;
    border-spacing: 0;
    > tbody > tr > td, > thead > tr > th {
      border: 0;
    }
    > thead {
      background: #eff4fb;
    }
    > tbody {
      background: #f6faff;
    }
  }

  .table-product-list {
    > thead > tr > th {
      padding: 5px 5px 5px 0;
    }
    > tbody > tr > td {
      padding: 2px 5px 2px 0;
    }
  }

  .table-product-list {
    margin-bottom: 0;
  }

  .product-title {
    text-align: center;
    border: 1px solid #eee;
    background: #eee;
  }
</style>
<template>
  <div v-if="isShowGoodsList" class="order-goods-info">
    <table class="table no-border table-product-list order-list-detail">
      <thead>
      <tr>
        <th width="30" class="text-center">序号</th>
        <th width="400">货品</th>
        <th>规格</th>
        <th>批号</th>
        <th>数量</th>
        <th>单价</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(product, index) in orderItem.details">
        <td width="30" class="text-center">{{index + 1}}</td>
        <td style="width: 400px">
          <span>{{product.goodsName}}</span>
        </td>
        <td style="width: 100px">{{product.specification}}
        </td>
        <td align="left" class="R">
          {{ product.batchNumber || '无' }}
        </td>
        <td align="left">
          {{product.orderAmount}} <dict :dict-group="'measurementUnit'" :dict-key="product.measurementUnit"/>
          <order-goods-package-count :item="product" :count="product.orderAmount"/>
        </td>
        <td align="left">
          <span v-if="product.orderPrice">￥{{product.orderPrice}}</span>
          <span v-if="!product.orderPrice">-</span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
  import OrderGoodsPackageCount from "@/components/common/order-goods-package-count";
  export default {
    components: {OrderGoodsPackageCount},
    props: {
      orderItem: {}
    },
    computed: {
      isShowGoodsList() {
        return this.$store.state.isShowGoodsList;
      }
    },
    methods: {
      packingConversionCount(item) {
        if (!item) {
          return "";
        }
        let orderAmount = item.orderAmount;
        let ratio = item.packingConversionRatio;
        let ratioUnit = item.packingConversionRatioUnit;
        if (!orderAmount || !ratio || !ratioUnit) {
          return "";
        }
        // 求余
        let count = Math.floor(orderAmount / ratio);
        let left = orderAmount % ratio;
        if (isNaN(count) && isNaN(left)) {
          return "";
        }
        if (count === 0 && left !== 0) {
          return left;
        }
        if (count !== 0 && left === 0) {
          return count + ' ' + ratioUnit;
        }
        if (count !== 0 && left !== 0) {
          return count + ' ' + ratioUnit + ' ' + left;
        }
      },
      showLeftCount(item) {
        if (!item) {
          return "";
        }
        let orderAmount = item.orderAmount;
        let ratio = item.packingConversionRatio;
        if (!orderAmount || !ratio) {
          return "";
        }
        let left = orderAmount % ratio;
        if (isNaN(left) || left === 0) {
          return "";
        }
        return left;
      }
    }
  };
</script>
